export default {
  addError(context, error) {
    const text = context.getters.toString(error);

    context.commit('addError', text);

    return new Promise((resolve) => { resolve(text); });
  },
  show404(context) {
    const text = 'Страница не найдена';
    context.commit('addError', text);

    return new Promise((resolve) => { resolve(text); });
  },
  showErrorToken(context) {
    const text = 'Ошибка получения токена, необходимо обновить страницу';
    context.commit('addError', text);

    return new Promise((resolve) => { resolve(text); });
  },
};
